import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LabelEditorFilter =
  | { type: 'showAllWithoutLabel' }
  | { type: 'labels'; labelIds: string[] };

interface LabelEditorStoreState {
  filter: LabelEditorFilter;
  scrollToParagraaf: ((paragraafId: string) => void) | null;
}

interface LabelEditorStoreActions {
  setFilter: (filter: LabelEditorFilter) => void;
  removeSelectedLabelId: (labelId: string) => void;
  setScrollToParagraaf: (fn: ((paragraafId: string) => void) | null) => void;
}

export const useLabelEditorStore = create<
  LabelEditorStoreState & LabelEditorStoreActions
>()(
  persist(
    (set) => ({
      filter: { type: 'labels', labelIds: [] },
      setFilter: (filter) => set({ filter }),
      removeSelectedLabelId: (labelId) =>
        set((state) => {
          if (state.filter.type !== 'labels') return state;
          return {
            filter: {
              type: 'labels',
              labelIds: state.filter.labelIds.filter((id) => id !== labelId),
            },
          };
        }),
      scrollToParagraaf: null,
      setScrollToParagraaf: (scrollToParagraaf) => set({ scrollToParagraaf }),
    }),
    {
      name: 'label-editor-store',
      partialize: (state) => ({
        filter: state.filter,
      }),
    }
  )
);
